import { domainEvent } from "@lookiero/messaging";
const UI_SETTING_REMOVED = "ui_setting_removed";
const uiSettingRemoved = ({ aggregateId }) => domainEvent({ aggregateId, name: UI_SETTING_REMOVED });
const isUiSettingRemoved = (event) => event.name === UI_SETTING_REMOVED;
export { UI_SETTING_REMOVED, uiSettingRemoved, isUiSettingRemoved };
